<template>
  <section class="website-section content-wrapper index-content" v-if="$store.getters.isLoaded">
    <app-header></app-header>
    <div class="hero" :style="{backgroundImage:'url(' + $store.getters.settings.client.header_image + ')'}">
      <div class="hero-wrapper">
        <div class="hero-title">Introducing {{ $store.getters.settings.client.name}}</div>
        <div class="hero-desc">
          <p>{{ $store.getters.settings.client.slogan }}</p>
        </div>
      </div>
    </div>
    <content-row v-for="row in homeContent" :key="row.id" :row="row" v-if="$store.getters.isLoaded">
    </content-row>
  </section>
</template>
<script>
  import ContentRow from './ContentRow.vue'
  import appHeader from '../layout/Header.vue'

  export default {
    computed: {
      homeContent () {
        return this.$store.getters.sections[0].content
      }
    },
    components: {
      ContentRow,
      appHeader
    },
    created () {},
    methods: {
      logout () {
        this.$auth.logout({
          redirect: {name: 'Login'}
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Home.vue